  <header-web (dataEvent)='setLanguage($event)'></header-web>
  <h1>GALERIA</h1>

  <body class="aurora">
    <div class="aurora-one"></div>
    <div class="aurora-two"></div>
    <div class="aurora-three"></div>
    <h3 class="aurora-text text-white">Aurora</h3>
  </body>
  <footer-web></footer-web>
